import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ArchiveJobManager } from '../../../../managers/archive-job.manager';

@Component({
    selector: 'lex-add-archive-dialog',
    templateUrl: './add-archive-dialog.component.html',
    styleUrls: ['./add-archive-dialog.component.scss'],
    standalone: false
})
export class AddArchiveDialogComponent {
	public title: string;
	public currentDate: Date = new Date();

	constructor(private archiveJobManager: ArchiveJobManager, private dialogRef: MatDialogRef<AddArchiveDialogComponent, string>) {
		this.title = `Archive ${this.currentDate.toLocaleDateString('en-US', {year: 'numeric',month: '2-digit',day: '2-digit'})}`;
	}

	public ok() {
		this.archiveJobManager.createArchiveJob(this.title).subscribe(
			(response) => this.dialogRef.close(response.toString()),
			(error) => this.dialogRef.close('error: '+ error)
		);
	}
}